
import { Component, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { DataTableHeader } from 'vuetify';
import { TagInterface, TagRepositoryInterface } from '@/services/QC-V2/tag/interfaces';
import DeleteTagDialog from '@/components/dialogs/qc-v2/tag/DeleteTagDialog.vue';

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'tagRepositoryV2',
  ],
  components: {
    DeleteTagDialog,
  },
})
export default class Tags extends Vue {
  private loading: boolean = true;
  private tags: TagInterface[] = [];

  private search: string = '';
  private headers: DataTableHeader[] = [
    { text: 'ID', value: 'id' },
    { text: 'Label', value: 'label' },
    { text: 'Color', value: 'color' },
    { text: 'Deleted', value: 'deletedAt' },
    { text: 'Actions', value: 'actions', sortable: false },
  ];

  private readonly tagRepositoryV2!: TagRepositoryInterface;
  private deleteTagDialog: string = '';
  private deleteTagForDialog: TagInterface | false = false;

  private async created(): Promise<void> {
    await this.initialize();
  }

  private async initialize(): Promise<void> {
    this.tags = await this.tagRepositoryV2.getAllTags();
    this.loading = false;
  }

  private async createTag(): Promise<void> {
    await this.$router.push({ name: 'create_tag' });
  }

  private async editTag(tagId: number): Promise<void> {
    await this.$router.push({ name: 'update_tag', params: { tagId: String(tagId) } });
  }

  private async deleteTag(tag: TagInterface): Promise<void> {
    this.deleteTagForDialog = tag;
    this.deleteTagDialog = 'delete-tag-dialog';
  }
}
